import React from "react";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DatePicker} from "@mui/x-date-pickers/DatePicker/DatePicker";
import dayjs from "dayjs";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
interface Props {
  value: any;
  onChange: (value:any) => void;
}

export const DateField: React.ComponentType<Props> = ({value, onChange}) => {

  return (<>
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'en-gb'}>
      <DatePicker
        defaultValue={value === undefined ? null : dayjs(value)}
        onChange={(value, context) => {
          onChange(dayjs(value, 'YYYY-MM-DD').format('YYYY-MM-DD'));
        }}
        slotProps={{
          textField: {
            size: 'small',
          },
        }}
        format={'YYYY-MM-DD'}
      />
    </LocalizationProvider>
  </>);

}